import React, { memo } from 'react';
import { createIconSetFromIcoMoon } from 'react-native-vector-icons';
import icoMoonConfig from './selection.json';
const OriginIcon = createIconSetFromIcoMoon(
  icoMoonConfig,
  'icomoon',
  'icomoon.ttf'
);

export const Icon = memo(({ size = 24, ...rest }) => (
  <OriginIcon {...{ size }} {...rest} />
));
